import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ReactComponent as CombinedLayoutIcon } from '../../assets/icons/combined-layout.svg'
import { ReactComponent as SplitLayoutIcon } from '../../assets/icons/split-layout.svg'
import '../../styles/mockup-generator/_DesignModeSelectionModal.scss';
import { DESIGN_MODES } from './Step2Container';

const DesignModeSelectionModal = ({ isOpen, onSelectLayout }) => {
    return (
        <Modal
            isOpen={isOpen}
            backdrop="static"
            keyboard={false}
            centered
            className="design-mode-selection-modal"
        >
            <ModalHeader>
                Select method to customize products and generate mockups
            </ModalHeader>
            <ModalBody>
                <div className="layout-options">
                    <div className="layout-option" onClick={() => onSelectLayout(DESIGN_MODES.COMBINED)}>
                        <div className="icon-wrapper">
                            <CombinedLayoutIcon />
                        </div>
                        <h5>Combined layout</h5>
                        <p>Supports uploading a completed and print-ready file to generate mockups</p>
                    </div>

                    <div className="layout-option" onClick={() => onSelectLayout(DESIGN_MODES.SPLIT)}>
                        <div className="icon-wrapper">
                            <SplitLayoutIcon />
                        </div>
                        <h5>Split layout</h5>
                        <p>Supports uploading multiple design layers and customization of specific placements to generate mockups</p>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default DesignModeSelectionModal;
